import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

const BUCKET_LABELS = {
  day: "Days",
  week: "Weeks",
  month: "Months",
  year: "Years",
};

const SecondBarChart = ({ data }) => {
  const isApiFormat =
    data && data?.labels && data?.data && Array?.isArray(data?.labels);

  // Transform API format to Recharts format
  const chartData = isApiFormat
    ? data?.labels?.map((label, index) => ({
        month: label,
        value: data?.data[index],
      }))
    : data;

  if (!chartData || chartData.length === 0) {
    return (
      <div className="w-full h-[280px] flex items-center justify-center border border-gray-200 rounded-lg bg-gray-50">
        <p className="text-gray-600">No data available</p>
      </div>
    );
  }

  // Compute max value once
  const maxValue = Math?.max(...chartData?.map((d) => d?.value));

  return (
    <ResponsiveContainer width="98%" height={280}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 10, left: -10, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis dataKey="month" axisLine={{ stroke: "#D9D9D9" }}>
          <Label
            value={
              isApiFormat ? BUCKET_LABELS[data.bucket] || "Periods" : "Months"
            }
            position="insideBottom"
            offset={-10}
          />
        </XAxis>

        <YAxis
          width={100} // ensures big numbers aren't cut
          domain={[0, maxValue * 1.1]} // use maxValue here
          tickFormatter={(value) => new Intl.NumberFormat().format(value)}
          axisLine={{ stroke: "#D9D9D9" }}
        />

        <Tooltip formatter={(value) => new Intl.NumberFormat().format(value)} />

        <Bar dataKey="value" fill="#005C53" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SecondBarChart;
